import React from 'react';
import { Button, Heading, Text, VStack } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

import { AuthCard } from '../components/AuthCard';
import { AuthLayout } from '../components/Layout';

export const Unauthorized = () => (
    <AuthLayout>
        <AuthCard>
            <VStack spacing={5} align="center" textAlign="center">
                <Heading color="#5D697C" fontSize="33px">
                    Access denied
                </Heading>
                <Text color="#5D697C" maxW="360px">
                    Your account does not have permission to access the JoVE Admin UI.
                    Contact an administrator if you believe this is a mistake.
                </Text>
                <Button as={RouterLink} to="/signin" variant="brand" w="full" maxW="320px">
                    Back to sign in
                </Button>
            </VStack>
        </AuthCard>
    </AuthLayout>
);
